import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-arrow-back-icon/jb-arrow-back-icon.css.ts
var jb_arrow_back_icon_css_default = i`:host{display:inline-block;height:15px}svg{fill:var(--stroke-color, #141e55)}@media(forced-colors: active){svg{fill:CanvasText}}`;

export {
  jb_arrow_back_icon_css_default
};
